import { render, staticRenderFns } from "./sleep.vue?vue&type=template&id=22a5770e&scoped=true"
import script from "./sleep.vue?vue&type=script&lang=js"
export * from "./sleep.vue?vue&type=script&lang=js"
import style0 from "./sleep.vue?vue&type=style&index=0&id=22a5770e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a5770e",
  null
  
)

export default component.exports